import React from "react";
import LanguageTable from "../../Common/LanguageTable";
import { templateDefaultValue } from "@constants/template";
import { DeleteModal } from "../../Common/DeleteModal";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import classNames from "classnames";
import { t } from "i18next";
import { Styles } from "../../Website/CoverPage/Styles";
import { Table } from "../../Common/Table";
import { StyledLabel, StyledModal } from "@aureskonnect/react-ui";
import {
    RefreshIcon,
    StyledH2,
    StyledIconButton,
    TrashIcon,
} from "@aureskonnect/react-ui";
import { templateActions, templateStore } from "../../templateStore";
import swal from "@sweetalert/with-react";
import UpDownArrow from "../../Common/UpDownArrow";
import ReactSwitch from "react-switch";
import { Modal, ModalFooter, ModalBody, ModalHeader } from "reactstrap";
import ModalStore from "./ModalStore";
import { useSnapshot } from "valtio";
import { useFetchGlobal } from "../../../../../../api/hooks";

interface Product {
    Referance: string;
    Rank: number;
    Activer: boolean;
}

export function BannerTable({
    section,
    boutique,
    setModal,
    shopData,
}: any): JSX.Element {
    const { fetchGlobal } = useFetchGlobal();

    const [isDeleteModalOpened, setIsDeleteModalOpened] = React.useState<
        Record<string, boolean>
    >({});
    const [deletedId, setDeletedId] = React.useState<number | null>(null);
    const [path, setPath] = React.useState<string[]>([]);
    const [productsData, setProductsData] = React.useState<any[]>([]);

    const snap: any = useSnapshot(templateStore);

    const currentProducts = React.useMemo(() => {
        return (
            snap.template?.Application?.LaindingPage?.[boutique]?.BestProducts
                ?.Products || []
        );
    }, [snap.template, boutique]);

    const data = React.useMemo(() => {
        return currentProducts.length > 0
            ? JSON.parse(JSON.stringify(currentProducts))
            : [];
    }, [currentProducts]);

    React.useEffect(() => {
        const bestProductLoading = async () => {
            try {
                const result = await fetchGlobal<any>(
                    `${process.env.REACT_APP_CATALOGUE_ARTICLES}${shopData.id_franshise}/${shopData.shopId}`,
                    { method: "GET" }
                );
                setProductsData(result.data || []);
            } catch (error) {
                console.error("Error fetching product data:", error);
            }
        };
        bestProductLoading();
        // eslint-disable-next-line
    }, [shopData]);

    const enhancedData = React.useMemo(() => {
        return data.map((product: any) => {
            const match = productsData.find(
                (p: any) => p.Référence === product.Referance
            );
            return {
                ...product,
                imageUrl: match?.Image || "",
                designation: match?.Désignation || "",
            };
        });
    }, [data, productsData]);

    const handleDeleteItemOnClickEvent = () => {
        if (deletedId === null) return;
        const updatedData = currentProducts
            .filter((item: any) => item.Rank !== deletedId)
            .map((item: any, index: number) => ({ ...item, Rank: index + 1 }));

        templateActions.updateTemplate(path, updatedData);
        setIsDeleteModalOpened((prev) => ({ ...prev, [section]: false }));
        setDeletedId(null);
    };

    const OrderCell = ({ row, dragHandleProps, className }: any) => (
        <div
            className="d-flex align-items-center position-relative"
            style={{ gap: "20px" }}
        >
            <UpDownArrow
                dragHandleProps={dragHandleProps}
                className={className}
            />
            <span
                style={{
                    font: "normal normal 600 15px/20px Segoe UI",
                    minWidth: "20px",
                    textAlign: "center",
                }}
                className="epb_txt_fileOrderAS"
            >
                {row.original.Rank}
            </span>
        </div>
    );

    const UploaderCell = ({ row }: any) => (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <span
                style={{
                    fontSize: "14px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: "200px",
                }}
            >
                {row.original.designation}
            </span>
        </div>
    );

    const ImageCell = ({ row }: any) => {
        const imageUrl = row.original.imageUrl;
        return (
            <div style={{ width: "60px", height: "60px" }}>
                {imageUrl ? (
                    <img
                        src={imageUrl}
                        alt=""
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            borderRadius: "6px",
                        }}
                    />
                ) : (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            backgroundColor: "#eee",
                            borderRadius: "6px",
                        }}
                    />
                )}
            </div>
        );
    };

    const columns = React.useMemo(() => {
        const ActionsCell = ({ row }: any) => {
            const currentTemplate = templateActions.getNestedObject([
                "template",
                "Application",
                "LaindingPage",
                boutique,
                "BestProducts",
                "Products",
            ]);

            const handleToggleActive = () => {
                const updatedData = currentTemplate.map((item: Product) =>
                    item.Rank === row.original.Rank
                        ? { ...item, Activer: !item.Activer }
                        : item
                );

                templateActions.updateTemplate(
                    [
                        "template",
                        "Application",
                        "LaindingPage",
                        boutique,
                        "BestProducts",
                        "Products",
                    ],
                    updatedData
                );
            };

            return (
                <div className="d-flex align-items-center justify-content-end position-relative">
                    <ReactSwitch
                        uncheckedIcon={false}
                        checkedIcon={false}
                        handleDiameter={26}
                        offColor="#f7b4b8"
                        offHandleColor="#E30613"
                        checked={row.original.Activer}
                        onChange={handleToggleActive}
                        onColor="#c2eddd"
                        onHandleColor="#34C38F"
                        width={55}
                        height={20}
                        className="epb_icn_activeDesactiveAS"
                    />
                    <StyledIconButton
                        icon="TrashIcon"
                        onClick={() => {
                            setPath([
                                "template",
                                "Application",
                                "LaindingPage",
                                boutique,
                                "BestProducts",
                                "Products",
                            ]);
                            setDeletedId(row.original.Rank);
                            setIsDeleteModalOpened((prev) => ({
                                ...prev,
                                [section]: true,
                            }));
                        }}
                        aria-label="delete"
                        className="m-0 epb_icn_archiveFileAS"
                    >
                        <TrashIcon
                            style={{ fill: "red" }}
                            height={20}
                            width={20}
                        />
                    </StyledIconButton>
                </div>
            );
        };

        return [
            { Header: t("Rank"), accessor: "Rank", Cell: OrderCell },
            {
                Header: t("Product "),
                accessor: "Product",
                Cell: UploaderCell,
            },
            { Header: t("Image"), accessor: "imageUrl", Cell: ImageCell },

            { Header: t("Actions"), accessor: "Actions", Cell: ActionsCell },
        ];
    }, [boutique, section]);

    const handleResetOnClickEvent = () => {
        templateActions.updateTemplate(
            [
                "template",
                "Application",
                "LaindingPage",
                boutique,
                "BestProducts",
                "Products",
            ],
            []
        );
    };

    return (
        <div
            className="d-flex flex-column cursor__clz"
            style={{ gap: "10px", flexGrow: 1, minHeight: "300px" }}
        >
            <div className="d-flex justify-content-end align-items-center">
                <div
                    className="d-flex align-items-center"
                    style={{ gap: "20px" }}
                >
                    <StyledIconButton
                        title={t("Reset to default settings")}
                        outline
                        variant="danger"
                        className="m-0 p-0 epb_icn_resetModificationsAS"
                        icon="RefreshIcon"
                        onClick={handleResetOnClickEvent}
                    >
                        <RefreshIcon height={20} width={20} />
                    </StyledIconButton>

                    <CustomMainColorButton
                        rounded
                        variant="primary"
                        onClick={() => setModal(true)}
                        className={classNames("w-20 cmn_btn_SaveButton mr-5")}
                    >
                        {t("Add")}
                    </CustomMainColorButton>
                </div>
            </div>

            <div className="d-flex flex-column">
                <Styles>
                    <Table
                        columns={columns}
                        data={enhancedData}
                        section={section}
                        path={[
                            "template",
                            "Application",
                            "LaindingPage",
                            boutique,
                            "BestProducts",
                            "Products",
                        ]}
                    />
                </Styles>
            </div>

            <StyledModal
                toggle={() =>
                    setIsDeleteModalOpened((prev) => ({
                        ...prev,
                        [section]: false,
                    }))
                }
                isOpen={isDeleteModalOpened[section]}
                centered
            >
                <ModalHeader
                    toggle={() =>
                        setIsDeleteModalOpened((prev) => ({
                            ...prev,
                            [section]: false,
                        }))
                    }
                >
                    <span
                        className="text-uppercase"
                        style={{
                            fontFamily: "Segoe UI Semibold",
                            color: "#2b2828",
                            fontSize: "20px",
                        }}
                    >
                        {t("Delete an item")}
                    </span>
                </ModalHeader>
                <ModalBody>
                    <StyledLabel className="d-flex justify-content-center pl-3 m-0">
                        {t("Do you want to confirm the delete of this element")}
                    </StyledLabel>
                </ModalBody>
                <ModalFooter className="border-top-0">
                    <CustomMainColorButton
                        outline
                        variant="primary"
                        onClick={handleDeleteItemOnClickEvent}
                        rounded
                    >
                        {t("Delete")}
                    </CustomMainColorButton>
                    <CustomMainColorButton
                        rounded
                        className="mr-2"
                        variant="primary"
                        onClick={() =>
                            setIsDeleteModalOpened((prev) => ({
                                ...prev,
                                [section]: false,
                            }))
                        }
                    >
                        {t("Cancel")}
                    </CustomMainColorButton>
                </ModalFooter>
            </StyledModal>
        </div>
    );
}

function BestProduct({ shopData }: any) {
    const [modal, setModal] = React.useState<boolean>(false);
    const handleAddProducts = (products: any[]) => {
        const currentProducts =
            templateActions.getNestedObject([
                "template",
                "Application",
                "LaindingPage",
                shopData.boutique,
                "BestProducts",
                "Products",
            ]) || [];
        const existingReferences = new Set(
            currentProducts.map((product: any) => product.Referance)
        );

        const newProducts = products
            .filter((product) => !existingReferences.has(product.Référence))
            .map((product, index) => ({
                Referance: product.Référence,
                Rank: currentProducts.length + index + 1,
                Activer: true,
            }));

        if (newProducts.length === 0) {
            swal({
                icon: "info",
                content: (
                    <p>
                        {t("All selected products already exist in the list")}
                    </p>
                ),
                buttons: false,
                timer: 4000,
            });
            return;
        }

        if (newProducts.length < products.length) {
            swal({
                icon: "info",
                content: (
                    <p>
                        {t("productsSummary", {
                            count: newProducts.length,
                            skipped: products.length - newProducts.length,
                        })}
                    </p>
                ),
                buttons: false,
                timer: 4000,
            });
        } else {
            swal({
                icon: "success",
                text:
                    newProducts.length > 1
                        ? t("{{count}} Products added to the list", {
                              count: newProducts.length,
                          })
                        : t("One product added to the list"),
                buttons: false,
                timer: 4000,
            });
        }
        templateActions.updateTemplate(
            [
                "template",
                "Application",
                "LaindingPage",
                shopData.boutique,
                "BestProducts",
                "Products",
            ],
            [...currentProducts, ...newProducts]
        );
    };

    return (
        <div className="banner-container">
            <section className="text-section">
                <div className="banner-images">
                    <BannerTable
                        boutique={shopData.boutique}
                        setModal={setModal}
                        shopData={shopData}
                    />
                </div>
                <LanguageTable
                    path={[
                        "Application",
                        "LaindingPage",
                        shopData.boutique,
                        "BestProducts",
                    ]}
                    fields={[
                        {
                            key: "Title",
                            label: "Title",
                            placeholder: "Enter the Title",
                        },
                    ]}
                    defaultTexts={
                        templateDefaultValue.Application.LaindingPage.Default
                            .BestProducts
                    }
                    sectionTitle="Title"
                />
                <Modal
                    centered
                    backdrop="static"
                    fade={false}
                    scrollable
                    className="modal-wrapper__clz"
                    isOpen={modal}
                >
                    <ModalHeader
                        toggle={() => {
                            setModal!(!modal);
                        }}
                    >
                        <StyledH2>{t("ADD BEST PRODUCTS")}</StyledH2>
                    </ModalHeader>

                    <ModalBody>
                        <ModalStore
                            id_franshise={shopData.id_franshise}
                            shopId={shopData.shopId}
                            onAddProducts={handleAddProducts}
                            onClose={() => setModal(false)}
                        />
                    </ModalBody>
                </Modal>
                <DeleteModal section="BestProducts" />
            </section>
        </div>
    );
}

export default BestProduct;
